import React from 'react';

const Label = (props) => {
    const {
        name    = '',
        label   = '',
    } = props;

    if (!label || label === '') {
        return null;
    }

    return (
        <label htmlFor={name}>{label}</label>
    );
}

export default Label;
